<template>
    <div class="p-6 pb-10 shadow-md rounded-md">
        <h3 class="text-2xl font-bold">Default answer label options</h3>
        <p class="text-base leading-5">
            {{ questionType.type }}
        </p>
        <div class="mt-6">
            <form @submit.prevent="submit">
                <div class="lg:w-1/2">
                    <div v-if="form.questionType === 1">
                        <div  class="custom-field mb-6">
                            <div v-for="(answer, answerValue) in form.answerLabelOptions"
                                 :key="'qa-' + questionType.id + '-' + answerValue"
                                 class="mb-6">
                                <div class="block text-sm mb-1">
                                    <div class="relative">
                                        <div
                                            class="absolute inset-y-0 left-0 px-3 flex items-center justify-center text-sm font-medium leading-5 text-gray-700 border-r border-gray-300 dark:border-gray-600 dark:text-gray-300 rounded-l-md"
                                            :style="{ color: answer.textColor }"
                                        >
                                            {{ answerValue }}
                                        </div>
                                        <input v-model="answer.label"
                                               type="text"
                                               :placeholder="answerLabelExamples[questionType.id][answerValue]"
                                               class="pl-10 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray border-white focus:border-white form-input"
                                               :style="{ color: answer.textColor, backgroundColor: answer.bgColor }"
                                        >
                                    </div>
                                </div>
                                <div class="colors grid xl:grid-cols-2 gap-3 pl-10">
                                    <label class="flex flex-wrap items-center text-sm">
                                        <span class="text-gray-700 dark:text-gray-400 block w-full mb-1">Background color:</span>
                                        <input :value="answer.bgColor || '#000000'" type="color"
                                               @input.prevent.stop="answer.bgColor = $event.target.value"
                                               class="block py-0 px-1 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray border-dark focus:border-darkh form-input">
                                        <input type="text" v-model.trim="answer.bgColor"
                                               class="block py-0 px-1 ml-2 w-1/2 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray border-dark focus:border-darkh form-input">
                                        <button
                                            @click.prevent="answer.bgColor = null"
                                            class="flex items-center justify-between ml-1 p-1 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-dark border border-transparent rounded-lg hover:bg-darkh focus:outline-none focus:shadow-outline-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                 viewBox="0 0 24 24" stroke="white">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      stroke-width="2"
                                                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                            </svg>
                                        </button>
                                    </label>
                                    <label class="flex flex-wrap items-center text-sm">
                                        <span class="text-gray-700 dark:text-gray-400 block w-full mb-1">Text color:</span>
                                        <input :value="answer.textColor || '#000000'"
                                               @input.prevent.stop="answer.textColor = $event.target.value"
                                               type="color"
                                               class="block py-0 px-1 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray border-dark focus:border-darkh form-input">
                                        <input type="text" v-model.trim="answer.textColor"
                                               class="block py-0 px-1 ml-2 w-1/2 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray border-dark focus:border-darkh form-input">
                                        <button
                                            @click.prevent="answer.textColor = null"
                                            class="flex items-center justify-between ml-1 p-1 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-dark border border-transparent rounded-lg hover:bg-darkh focus:outline-none focus:shadow-outline-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                 viewBox="0 0 24 24" stroke="white">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      stroke-width="2"
                                                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                            </svg>
                                        </button>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between items-center">
                    <jet-action-message :on="form.recentlySuccessful" class="ml-auto mr-3">
                        Saved.
                    </jet-action-message>
                    <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" :bg-dark="true">
                        Save fields
                    </jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import JetInput from "@/Jetstream/Input";
import JetActionMessage from "@/Jetstream/ActionMessage";
import JetButton from '@/Jetstream/Button.vue'
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "SurveyDefaultLabelsForm",
    components: {
        JetActionMessage,
        JetButton,
        JetInput,
    },
    props: {
        surveyType: {
            type: Number,
            required: true,
        },
        answerLabelOptions: {
            type: Object,
            required: true,
        },
        questionType: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const answerLabelExamples = {
            1: {
                1: 'eg: Very low',
                2: 'eg: Low',
                3: 'eg: Medium',
                4: 'eg: High',
                5: 'eg: Very high',
            },
        };

        const form = useForm({
            surveyType: props.surveyType,
            questionType: props.questionType.id,
            answerLabelOptions: props.answerLabelOptions,
        });

        const submit = () => {
            form
                .transform(data => ({
                    ...data,
                }))
                .put(route('admin.survey.defaults.save'), {
                    errorBag: 'answerLabelOptions',
                    preserveScroll: true,
                })
        }
        return {
            answerLabelExamples,
            form,
            submit
        };
    },
}
</script>

<style scoped>

</style>
